
import { api } from "../../src/component/constent";

  export const currentMonth = (month, year) =>
  api.get("/reports/currentMonth");


 export const getDashboardDataStatus = (month, year) =>
  api.get("/reports/status", { params: { month,  year, }, });

 

     export const dataFinalised = (month, year) =>
  api.post("/procedure/execute", {reportId: 36, params: [month, year],});



